const IngredientListItemLoading = () => (
  <div className="my-1">
    <div
      className={`
        flex items-center gap-2 cursor-pointer px-4 py-4
      `}
    >
      <div className="animate-pulse flex space-x-4 w-full">
        <div className="flex-1 space-y-6 py-1">
          <div className="space-y-3">
            <div className="grid grid-cols-3 gap-4">
              <div className="h-3 bg-gray-300 rounded col-span-2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default IngredientListItemLoading
